import React, { FC, ReactNode, memo } from 'react';

import { Popover, PopoverVirtualElement } from '@mui/material';

import useStyles from './styles.module';

interface Props {
  onClose: () => void;
  anchorEl:
    | null
    | Element
    | (() => Element)
    | PopoverVirtualElement
    | (() => PopoverVirtualElement);
  children: ReactNode;
}

const CustomPopover: FC<Props> = ({ anchorEl, children, onClose }) => {
  const { classes } = useStyles();

  return (
    <Popover
      id="mouse-over-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      className={classes.popover}
      sx={{ pointerEvents: 'none' }}
      hideBackdrop
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      {children}
    </Popover>
  );
};

export default memo(CustomPopover);
